export default __webpack_public_path__ + "static/char-s-31-ja-64a9e406d9db153fd9bbb041525ed44d.png";